// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gBDkogPb88r6aI {
  box-sizing: border-box;
  border-radius: var(--ds-radius-xlarge, 12px);
  background-color: var(--ds-surface-overlay, #fff);
  width: 768px;
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
  position: relative;
  overflow: hidden;
}

.gBDkogPb88r6aI:focus {
  outline: none;
}

.gBDkogPb88r6aI.HmnSxKZSlWWUAo {
  width: 1008px;
}

.gBDkogPb88r6aI.GKgjHLf2Y6f69K {
  width: 768px;
}

.gBDkogPb88r6aI.hww13lqnWLU9MY {
  width: 584px;
}

.gBDkogPb88r6aI.JzqEz6pOkiTC7_ {
  width: 500px;
}

@media print {
  .gBDkogPb88r6aI {
    border-radius: 0 !important;
    width: 100vw !important;
  }
}

.od1KDrTLwT0jWf {
  box-shadow: none;
  margin: var(--ds-space-0, 0) var(--ds-space-100, 8px) auto;
  border-radius: var(--ds-radius-full, 50%);
  background-color: #0000;
  border: none;
}

.od1KDrTLwT0jWf:after {
  display: none;
}

.od1KDrTLwT0jWf .bYG5UtOFYFT5vZ {
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  display: inline-flex;
}

.od1KDrTLwT0jWf .bYG5UtOFYFT5vZ svg {
  scale: 1.25;
}

.od1KDrTLwT0jWf:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  box-shadow: none;
}

.od1KDrTLwT0jWf:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  box-shadow: none;
}

.od1KDrTLwT0jWf:focus {
  outline: var(--ds-border-width-focused, 2px) solid var(--ds-border-focused, #388bff);
  outline-offset: 2px;
}

.mac .od1KDrTLwT0jWf:focus {
  outline-color: -webkit-focus-ring-color;
}

.od1KDrTLwT0jWf:focus .mac.firefox {
  outline-color: accentcolor;
}

.od1KDrTLwT0jWf .X7_2PU1pM5TEk6 {
  margin: var(--ds-space-0, 0);
}

@media only screen and (width <= 750px), only screen and (width <= 450px) {
  .gBDkogPb88r6aI {
    width: auto;
    margin: var(--ds-space-0, 0) var(--ds-space-100, 8px);
  }

  .gBDkogPb88r6aI.HmnSxKZSlWWUAo, .gBDkogPb88r6aI.GKgjHLf2Y6f69K, .gBDkogPb88r6aI.hww13lqnWLU9MY, .gBDkogPb88r6aI.JzqEz6pOkiTC7_ {
    width: auto;
  }

  .gBDkogPb88r6aI .X7_2PU1pM5TEk6 {
    margin: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-150, 12px) var(--ds-space-150, 12px);
  }
}

.avibjShXPsokbL {
  width: 1px;
  height: 1px;
  padding: var(--ds-space-0, 0);
  clip: rect(0 0 0 0);
  word-wrap: normal;
  white-space: nowrap;
  border: 0;
  margin: -1px;
  position: absolute;
  overflow: hidden;
}
`, ""]);
// Exports
export var dialog = `gBDkogPb88r6aI`;
export var xlarge = `HmnSxKZSlWWUAo`;
export var large = `GKgjHLf2Y6f69K`;
export var medium = `hww13lqnWLU9MY`;
export var small = `JzqEz6pOkiTC7_`;
export var closeButton = `od1KDrTLwT0jWf`;
export var largeIcon = `bYG5UtOFYFT5vZ`;
export var body = `X7_2PU1pM5TEk6`;
export var liveRegion = `avibjShXPsokbL`;
export default ___CSS_LOADER_EXPORT___;
